import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["home", "away", "flag"]

  swap() {
    const homeText = this.homeTarget.textContent
    this.homeTarget.textContent = this.awayTarget.textContent
    this.awayTarget.textContent = homeText

    this.flagTarget.value = this.flagTarget.value === "true" ? "false" : "true"
  }
}
